import React, { useState } from "react";
import ButtonList from "./ButtonList";
import VideoContainer from "./VideoContainer";

const MainContainer = ({searchQuery}) => {

  const [buttonIndex,setButtonIndex] = useState();

  return (
    <div className="md:pl-36 w-screen">
      <ButtonList />
      <VideoContainer />
    </div>
  );
};

export default MainContainer;
